module.exports = __webpack_public_path__ + "static/media/27OCHA17.5af23ca0.jpg";